import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Alert,
  Box,
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';

export default function CreateItemPhase({
  productGroups,
  values,
  errors,
  error,
  saving,
  onChange,
  onSave,
  onCancel,
}) {
  const { t } = useTranslation(['inventory', 'common']);

  return (
    <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', p: 2, gap: 2, overflow: 'auto' }}>
      <Typography variant="subtitle1" fontWeight={600}>
        {t('inventory:scanner.create_item')}
      </Typography>

      {error && <Alert severity="error">{error}</Alert>}

      <FormControl size="small" fullWidth required error={Boolean(errors.product_group_id)}>
        <InputLabel id="create-item-phase-product-group-label">{t('inventory:items.create_form.product_group')}</InputLabel>
        <Select labelId="create-item-phase-product-group-label"
          value={values.product_group_id}
          onChange={(e) => onChange('product_group_id', e.target.value)}
          label={t('inventory:items.create_form.product_group')}
        >
          {productGroups.map((g) => (
            <MenuItem key={g.product_group_id} value={g.product_group_id}>
              {g.code} · {g.name}
            </MenuItem>
          ))}
        </Select>
        {errors.product_group_id && <FormHelperText>{errors.product_group_id}</FormHelperText>}
      </FormControl>

      <TextField
        label={t('inventory:items.create_form.sku')}
        value={values.sku}
        onChange={(e) => onChange('sku', e.target.value)}
        size="small"
        fullWidth
        required
        error={Boolean(errors.sku)}
        helperText={errors.sku}
        slotProps={{ htmlInput: { maxLength: 100 } }}
      />

      <TextField
        label={t('inventory:items.create_form.name')}
        value={values.name}
        onChange={(e) => onChange('name', e.target.value)}
        size="small"
        fullWidth
        required
        error={Boolean(errors.name)}
        helperText={errors.name}
      />

      <TextField
        label={t('inventory:items.create_form.uom')}
        value={values.uom}
        onChange={(e) => onChange('uom', e.target.value)}
        size="small"
        fullWidth
        required
        error={Boolean(errors.uom)}
        helperText={errors.uom}
        slotProps={{ htmlInput: { maxLength: 20 } }}
      />

      <TextField
        label={t('inventory:items.create_form.description')}
        value={values.description}
        onChange={(e) => onChange('description', e.target.value)}
        size="small"
        fullWidth
        multiline
        rows={2}
        slotProps={{ htmlInput: { maxLength: 1000 } }}
      />

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 'auto', pt: 1 }}>
        <Button
          variant="contained"
          size="large"
          onClick={onSave}
          disabled={saving}
          fullWidth
          sx={{ minHeight: 52 }}
        >
          {saving ? t('common:buttons.saving') : t('common:buttons.create')}
        </Button>
        <Button
          variant="outlined"
          size="large"
          onClick={onCancel}
          disabled={saving}
          fullWidth
          sx={{ minHeight: 52 }}
        >
          {t('common:buttons.cancel')}
        </Button>
      </Box>
    </Box>
  );
}
